import { HorizontalBar } from 'vue-chartjs'

export default {
  extends: HorizontalBar,
  props: {
    nutritions: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      loaded: false
    }
  },
  updated () {
    if (!this.loaded && this.$refs.canvas && this.nutritions.length > 0) {
      this.load()
      this.loaded = true
    }
  },
  watch: {
    criteria () {
      this.load()
    }
  },
  computed: {
    _nutritions () {
      return this.nutritions.filter(nutri => nutri.recommend).map(nutri => {
        if (!nutri.base) nutri.base = (nutri.recommend[0] + nutri.recommend[1]) / 2
        return nutri
      })
    },
    labels () {
      if (this._nutritions != null)
        return this._nutritions.map(nutri => nutri.name)
    },
    amount () {
      if (this._nutritions != null)
        return this._nutritions.map(nutri => nutri.value)
    },
    recommend () {
      if (this._nutritions != null)
        return this._nutritions.map(nutri => nutri.recommend)
    },
    norm_amount () {
      if (this._nutritions != null)
        return this._nutritions.map(nutri => nutri.value / nutri.base)
    },
    norm_recommend () {
      if (this._nutritions != null)
        return this._nutritions.map(nutri => [nutri.recommend[0]/nutri.base, nutri.recommend[1]/nutri.base])
        // return this._nutritions.map(nutri => nutri.recommend.map(v => v/nutri.base))
    },
    datasets () {
      return [
          {
          label: '제품 함유량',
          backgroundColor: 'rgba(54, 162, 235, 0.8)',
          maxBarThickness: 20,
          data: this.norm_amount
        }, 
        {
          label: '1일 영양성분 기준치',
          data: this.norm_amount.map(a => 1),
          maxBarThickness: 20,
          backgroundColor: 'rgba(0, 0, 0, 0.3)'
        },
        {
          label: '권장 섭취량',
          // backgroundColor: this.norm_amount.map((a, a_i) => {
          //   if (a < this.norm_recommend[a_i][0])
          //     return 'rgba(255, 0, 0, 0.8)'
          //   else
          //     return 'rgba(0, 0, 0, 0.5)'
          // }),
          backgroundColor: 'rgba(0, 0, 0, 0.1)',
          maxBarThickness: 20,
          data: this.norm_recommend,
        }
      ]
    }
  },
  methods: {
    tooltip (tooltipItem, data) {
      let label = tooltipItem.label
      let index = data.labels.indexOf(label)
      if (tooltipItem.datasetIndex == 0) {
        return `제품 함유량: ${this.amount[index]} ${this._nutritions[index].unit}`
      }
      else if (tooltipItem.datasetIndex == 1){
        return `1일 영양성분 기준치: ${this._nutritions[index].base} ${this._nutritions[index].unit}`
      }
      else if (tooltipItem.datasetIndex == 2){
        return `권장 섭취량: ${this.recommend[index][0]} ~ ${this.recommend[index][1]} ${this._nutritions[index].unit}`
      }
    },
    ylabel (value, index) {
      // if (this.norm_amount[index] >= 1) 
      return `${value}(${Math.round(this.norm_amount[index] * 100)}%)`
    },
    load () {
      let self = this
      this.renderChart({
        labels: this.labels,
        datasets: this.datasets
      }, {
        tooltips: {
          position: 'nearest',
          callbacks: {
            label: this.tooltip
          }
        },
        scales: {
          yAxes: [{
            stacked: true,
            ticks: {
              fontFunction: (idx) => {console.log(idx)},
              callback: self.ylabel
            }
          }],
          xAxes: [{
            ticks: {
              beginAtZero: true,
              callback: function(value, index, values) {
                return Math.round(100 * value) + '%';
              },
              max: 2
            },
          }]
        },
        responsive: true,
        maintainAspectRatio: false
      })
    }
  }
}


// WEBPACK FOOTER //
// ./src/components/common/NutriChart.js